import Calendar from "../../entities/calendar/calendar";

export default class BookingCalendarManager {

    constructor(flatpickr, flatpickrLangs, calendarData, locale, onOpenCalendar, onCloseCalendar, showBackdrop = true, dateFormat = "d-m-Y", startParameter = null, endParameter = null, disabledDates = [], onDayCreate = () => {}, completeDatesModule = false) {
        this.flatpickr = flatpickr;
        this.flatpickrLangs = flatpickrLangs;
        this.locale = locale;
        this.calendarData = calendarData;
        this.outsideOnOpenCalendar= onOpenCalendar;
        this.outsideOnCloseCalendar= onCloseCalendar;
        this.showBackdrop = showBackdrop;
        this.dateFormat = dateFormat;
        this.startParameter = startParameter
        this.endParameter = endParameter
        this.maxNumDaysRange = 14;
        this.dateSummaryContainerTemplate = completeDatesModule
            ? '<div name="summary-title"></div><div name="summary-date"></div>'
            : '<div name="summary-day"></div><div><div name="summary-weekday"></div><div name="summary-month"></div></div>';
        this.disabledDates = disabledDates;
        this.completeDatesModule = completeDatesModule;
        this.onDayCreate = onDayCreate;
        this.initializeCalendar();
        this.eventDelegation();
        this.configureCalendar();
    }

    initializeCalendar() {
        this.calendar = new Calendar(
            this.flatpickr,
            this.flatpickrLangs,
            this.calendarData.id,
            document.querySelector('#'+this.calendarData.id),
            document.querySelector('[data-container="'+this.calendarData.id+'"]'),
            this.onChangeBookingDates.bind(this),
            this.onCloseCalendar.bind(this),
            this.onOpenCalendar.bind(this),
            this.initializeView.bind(this),
            this.locale,
            this.disabledDates,
            this.onDayCreate
        );

        this.anyDatesButton = !!document.querySelector('[data-type="any-dates"]');

        if (this.anyDatesButton) {
            this.resizeCalendar();
        }

        if (this.showBackdrop) {
            this.createBackdrop();
        }
    }

    eventDelegation() {
        for (let element of document.querySelectorAll('[data-toggle="'+this.calendarData.id+'"]')) {
            element.addEventListener("click", (event) => {
                if (this.anyDatesButton) {
                    this.resizeCalendar();
                }
                this.calendar.toggle();
            });
        }

        if (this.anyDatesButton) {
            document.querySelector('[data-type="any-dates"]').addEventListener("click", (event) => {
                const currentTarget = event.currentTarget;
                let form = document.querySelector('#form-searcher');
                let button = document.querySelector('[data-button="calendar"]');
                let searcherDates =  form.querySelector('[data-searcher-dates]');
                let anyDates = form.querySelector('[data-any-search]')

                currentTarget.classList.toggle('checked');
                document.querySelector('[data-input="booking-dates"]').classList.remove('input-error');

                if (currentTarget.classList.contains('checked')) {
                    form.action = form.dataset.anyTypeAction;
                    searcherDates.style.display = "none";
                    anyDates.style.display = "";
                    button.classList.remove('disabled');
                    button.innerHTML = this.calendarData.translations.anyDateButton;
                    $('#dropdown-destination').removeClass('input-error');
                    this.resetBookingDates();
                } else {
                    form.action = form.dataset.searcherAction;
                    searcherDates.style.display = "";
                    anyDates.style.display = "none";
                    button.classList.remove('vpt-btn-complementary');
                    button.classList.add('vpt-btn-secondary-darker', 'disabled');
                }
            });
        }
    }

    onChangeBookingDates(selectedDates, dateStr, element) {
        let summaryContainer = document.querySelector('#'+this.calendarData.summary);
        let button = summaryContainer.querySelector('[data-button="calendar"]');
        let buttonAnyDate = document.querySelector('[data-type="any-dates"]');

        if (buttonAnyDate && buttonAnyDate.classList.contains('checked')) {
            buttonAnyDate.classList.remove('checked');
            let form = document.querySelector('#form-searcher');
            form.action = form.dataset.searcherAction;
            form.querySelector('[data-searcher-dates]').style.display = "";
            form.querySelector('[data-any-search]').style.display = "none";
        }

        if (selectedDates.length === 1) {
            this.calendar.setMinDate(this.getMinDate(selectedDates[0]));
            this.calendar.setMaxDate(selectedDates[0].fp_incr(this.maxNumDaysRange));
            this.setDate(this.calendarData.dates.start, selectedDates[0], element);
            this.resetDate(this.calendarData.dates.end);
            button.innerHTML = this.calendarData.translations.buttonPlaceholder;
            button.classList.remove('vpt-btn-complementary');
            button.classList.add('disabled');
            button.classList.add('vpt-btn-secondary-darker');
        } else {
            if (this.checkSelectedDates(selectedDates)) {
                this.calendar.setMinDate(this.calendar.getDefaultMinDate());
                this.calendar.setMaxDate(null);
                this.setDate(this.calendarData.dates.start, selectedDates[0], element);
                this.setDate(this.calendarData.dates.end, selectedDates[1], element);
                let numNights = Math.round((selectedDates[1].getTime() - selectedDates[0].getTime()) / (1000 * 3600 * 24));
                button.innerHTML = this.calendarData.translations.button.replace('%%numNights%%', parseInt(numNights));
                button.classList.remove('disabled');
                button.classList.remove('vpt-btn-secondary-darker');
                button.classList.add('vpt-btn-complementary');
                this.resetSelectedElement(numNights)
            } else {
                this.resetBookingDates();
            }
        }
    }

    checkSelectedDates(selectedDates) {
        return (selectedDates.length === 2 && selectedDates[0].getTime() !== selectedDates[1].getTime()) ? true : false;
    }

    getMinDate(date) {
        const defaultMinDate = this.calendar.getDefaultMinDate();
        let minDate = date.fp_incr(-this.maxNumDaysRange);
        if (minDate.getTime() < defaultMinDate.getTime()) {
            minDate = defaultMinDate;
        }
        return minDate;
    }

    setDate(dateData, date, calendar) {
        let inputCalendar = document.querySelector('[data-input-calendar="'+this.calendarData.id+'"]');
        let dateTextElement =  inputCalendar.querySelector('[data-date-text="'+dateData.type+'"]');
        dateTextElement.innerHTML = date.toLocaleDateString(this.locale, {
            month: "short",
            day: "numeric",
            year: "numeric"
        }).replace(/ de /g, ' ');
        dateTextElement.classList.remove('placeholder');
        document.querySelector(dateData.dateInput).value = calendar.formatDate(date, this.dateFormat);
        let summaryContainer = document.querySelector('#'+this.calendarData.summary);
        let summaryDateElement =  summaryContainer.querySelector('[data-date-summary="'+dateData.type+'"]');
        summaryDateElement.innerHTML = '';
        let dateSummary = document.createElement('div');
        dateSummary.innerHTML = this.dateSummaryContainerTemplate;

        if (this.completeDatesModule) {
            dateSummary.classList.add('searcher-summary-date');
            dateSummary = this.updateCompleteDatesModule(dateData, date, this.locale, dateSummary);
        } else {
            dateSummary.classList.add('summary-date');
            dateSummary.querySelector('[name="summary-day"]').innerHTML = calendar.formatDate(date, "d");
            dateSummary.querySelector('[name="summary-weekday"]').innerHTML = date.toLocaleDateString(this.locale, {weekday: "long"});
            dateSummary.querySelector('[name="summary-month"]').innerHTML = date.toLocaleDateString(this.locale, {month: "long"});
        }
        summaryDateElement.appendChild(dateSummary);
    }

    resetDate(dateData) {
        let inputCalendar = document.querySelector('[data-input-calendar="'+this.calendarData.id+'"]');
        let dateTextElement =  inputCalendar.querySelector('[data-date-text="'+dateData.type+'"]');
        dateTextElement.innerHTML = dateData.placeholder;
        dateTextElement.classList.add('placeholder');
        document.querySelector(dateData.dateInput).value = '';
        let summaryContainer = document.querySelector('#'+this.calendarData.summary);
        let summaryDateElement =  summaryContainer.querySelector('[data-date-summary="'+dateData.type+'"]');
        summaryDateElement.innerHTML = dateData.placeholder;
    }

    resetBookingDates() {
        this.resetDate(this.calendarData.dates.start);
        this.resetDate(this.calendarData.dates.end);
        this.calendar.setDate(null);
        this.calendar.setMinDate(this.calendar.getDefaultMinDate());
        this.calendar.setMaxDate(null)
    }

    onCloseCalendar(selectedDates, dateStr, element) {
        if (!this.checkSelectedDates(selectedDates)) {
            this.resetBookingDates();
        }
        if (this.showBackdrop) {
            this.body.classList.remove('calendar-opened');
        }
        this.outsideOnCloseCalendar();
    }

    onOpenCalendar(selectedDates, dateStr, element) {
        if (this.showBackdrop) {
            this.body.classList.add('calendar-opened');
        }
        this.outsideOnOpenCalendar();
    }

    initializeView() {
        let calendarContainer = document.querySelector('[data-calendar-container="'+this.calendarData.id+'"]');
        calendarContainer.prepend(this.createTopContainer());
        if (this.calendarData.showTopContainer) {
            calendarContainer.prepend(this.createTopButton());

        }
        calendarContainer.appendChild(this.createBottomContainer());
    }

    createTopContainer() {
        let topContainer = document.createElement('div');
        topContainer.classList.add('top-container');
        topContainer.innerHTML= '<div data-toggle="'+this.calendarData.id+'"><i class="ci ci-angle-left ci-s-17"></i></div><div>'+this.calendarData.translations.title+'</div>';
        return topContainer;
    }

    createTopButton() {
        let topContainer = document.createElement('div');
        topContainer.dataset.type = 'any-dates-container';
        topContainer.classList.add('any-dates-container', 'pl-xs-3', 'pr-xs-3');

        let buttonContainer = document.createElement('div');
        buttonContainer.classList.add('any-date-btn');
        buttonContainer.dataset.type = 'any-dates';

        let iconCalendar = document.createElement('i');
        iconCalendar.classList.add('ci', 'ci-calendar-searcher', 'ci-s-26');

        let textCalendar = document.createElement('span');
        textCalendar.innerHTML = this.calendarData.translations.anyDate;
        textCalendar.classList.add('text-h4', 'color-secondary-darker');

        let separator = document.createElement('hr');
        separator.classList.add('color-secondary-light', 'd-none', 'd-lg-block');

        const buttonHeight = "125px"

        topContainer.appendChild(buttonContainer);
        buttonContainer.appendChild(iconCalendar);
        buttonContainer.appendChild(textCalendar);
        topContainer.appendChild(separator);

        document.querySelector('[data-calendar-container="booking-dates"] .flatpickr-next-month').style.top = buttonHeight;
        document.querySelector('[data-calendar-container="booking-dates"] .flatpickr-prev-month').style.top = buttonHeight;

        return topContainer;
    }

    createBottomContainer() {
        let bottomContainer = document.createElement('div');
        bottomContainer.classList.add('bottom-container');
        bottomContainer.id = this.calendarData.summary;
        let content = null;
        if (this.completeDatesModule) {
            content = '<div class="dates-summary complete-dates"><div data-date-summary="start">' + this.calendarData.dates.start.placeholder + '</div><i class="ci ci-arrow-right color-secondary-darker"></i><div data-date-summary="end">' + this.calendarData.dates.end.placeholder + '</div></div>' +
                '<div class="button-container"><div class="vpt-btn vpt-btn-secondary-darker disabled"  data-button="calendar" data-toggle="'+this.calendarData.id+'">' + this.calendarData.translations.buttonPlaceholder + '</div></div>';
        } else {
            content = '<div class="dates-summary"><div data-date-summary="start">' + this.calendarData.dates.start.placeholder + '</div><i class="ci ci-arrow-right"></i><div data-date-summary="end">' + this.calendarData.dates.end.placeholder + '</div></div>' +
                '<div class="button-container p-3"><div class="vpt-btn vpt-btn-complementary disabled"  data-button="calendar" data-toggle="'+this.calendarData.id+'">' + this.calendarData.translations.buttonPlaceholder + '</div></div>';
        }
        bottomContainer.innerHTML = content;
        return bottomContainer;
    }

    createBackdrop() {
        this.body = document.querySelector('body');
        let backdrop = document.createElement('div');
        backdrop.classList.add('calendar-backdrop');
        this.body.appendChild(backdrop);
    }

    getCalendar() {
        return this.calendar;
    }

    jumpToDate(date) {
        return this.calendar.jumpToDate(date);
    }

    resizeCalendar() {
        if (this.calendar) {
            this.calendar.redraw();
            this.calendar.updateMonthView();
        }
    }
    configureCalendar() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const start = params.get(this.startParameter);
        const end = params.get(this.endParameter);

        if ((params.has(this.startParameter) && params.has(this.endParameter)) && this.anyDatesButton) {
            if (!start && !end){
                document.querySelector('[data-type="any-dates"]').click();
            }
        }
    }

    resetSelectedElement(nightsSelected) {
        const searchedCholloId = document.querySelector('[name="searchedCholloId"]');
        if (searchedCholloId) {
            let updatedSelection = document.querySelector('#groupSubchollos [data-nights="'+nightsSelected+'"]');
            if (updatedSelection) {
                searchedCholloId.value = updatedSelection.querySelector('[data-searcher-subchollo]').getAttribute('data-chollo-id');
            } else {
                searchedCholloId.value = '';
            }
        }
    }

    updateCompleteDatesModule(dateData, date, locale, dateSummary) {
        let formattedDate = date.toLocaleDateString(locale, {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
        dateSummary.querySelector('[name="summary-title"]').innerHTML = dateData.placeholder;
        dateSummary.querySelector('[name="summary-date"]').innerHTML = formattedDate;
        return dateSummary;
    }
}